import './ResetButton.1478058bbee32369722301b0405bb86c.css';
export default {"resetButton":"_resetButton_1divl_1"};